import { z } from "zod";
import "@apexdesigner/schema-tools";
import { belongsTo, references } from "@apexdesigner/schema-tools";

export const roleAssignment = z
  .object({
    id: z.number().hidden().describe("Unique identifier"),

    userId: z.number().hidden().describe("Foreign key to User"),

    roleId: z
      .number()
      .nullable()
      .optional()
      .presentAs("reference")
      .describe("Foreign key to Role"),

    user: belongsTo("User"),

    role: references("Role"),
  })
  .describe(
    "Associates a user with a role. Belongs to User (cascade delete),\nreferences Role (prevents deletion while assignments exist).",
  )
  .as("RoleAssignment");

export { roleAssignment as roleAssignmentSchema };
